// import React, { useEffect, useState, useRef } from 'react';
// import ReactApexCharts from 'react-apexcharts';
// import { useSelector } from 'react-redux';
// import { getAvailability } from 'api';
// import moment from 'moment';

// const AreaChart = () => {
//   const [series, setSeries] = useState([]);
//   const [isDataAvailable, setIsDataAvailable] = useState(false);
//   const [isLoading, setIsLoading] = useState(true);
//   const lastRequestRef = useRef(null);
//   const requestTimeoutRef = useRef(null);

//   const date = useSelector((state) => state.customization.currentDate);
//   const selectedTime = useSelector((state) => state.customization.selectedTime);
//   const source = (localStorage.getItem('source'));
//   const departments = useSelector((state) => state.customization.departments);

  
//   const timeToDate = (dateStr, timeStr) => {
//     if (!timeStr) return null;
//     if (timeStr.includes('-')) {
//       const [start] = timeStr.split('-').map(t => t.trim());
//       timeStr = start;
//     }
//     const timeMoment = moment(timeStr, ['h:mm A', 'HH:mm']);
//     if (!timeMoment.isValid()) return null;
//     const dateMoment = moment(dateStr);
//     timeMoment.set({
//       year: dateMoment.year(),
//       month: dateMoment.month(),
//       date: dateMoment.date()
//     });
//     return timeMoment.toDate();
//   };



//   useEffect(() => {
//     const fetchData = async () => {
//       if (lastRequestRef.current) {
//         lastRequestRef.current.abort();
//       }

//       const controller = new AbortController();
//       lastRequestRef.current = controller;

//       try {
//         setIsLoading(true);

//         if (!date || !selectedTime || !departments?.length) {
//           setIsDataAvailable(false);
//           return;
//         }

//         const startTime = selectedTime?.start_time ? new Date(selectedTime.start_time) : new Date();
//         const endTime = selectedTime?.end_time ? new Date(selectedTime.end_time) : new Date();

//         const response = await getAvailability({
//           date: date.split('T')[0],
//           source_id: source,
//           start_time: startTime.toUTCString(),
//           end_time: endTime.toUTCString(),
//           departments: departments
//         }, { signal: controller.signal });

//         if (!response?.data?.length) {
//           setIsDataAvailable(false);
//           return;
//         }

//         const processData = (data, key) => {
//           return data
//             .map(item => {
//               const timestamp = timeToDate(date, item.time_range);
//               return timestamp ? { x: timestamp.getTime(), y: item[key] || 0 } : null;
//             })
//             .filter(Boolean);
//         };

//         const employeeData = processData(response.data, 'employee_count');
//         const customerData = processData(response.data, 'customer_count');

//         if (!employeeData.length && !customerData.length) {
//           setIsDataAvailable(false);
//           return;
//         }

//         setSeries([
//           { name: 'Employees', data: employeeData },
//           { name: 'Customers', data: customerData }
//         ]);
//         setIsDataAvailable(true);
//       } catch (error) {
//         if (error.name !== 'AbortError') {
//           console.error('API Error:', error);
//           setIsDataAvailable(false);
//         }
//       } finally {
//         setIsLoading(false);
//       }
//     };

//     if (requestTimeoutRef.current) {
//       clearTimeout(requestTimeoutRef.current);
//     }

//     requestTimeoutRef.current = setTimeout(() => {
//       fetchData();
//     }, 500);

//     return () => {
//       if (requestTimeoutRef.current) {
//         clearTimeout(requestTimeoutRef.current);
//       }
//       if (lastRequestRef.current) {
//         lastRequestRef.current.abort();
//       }
//     };
//   }, [date, selectedTime, source, departments]);

//   if (isLoading) {
//     return (
//       <div
//         className="chart-loading-container"
//         style={{
//           display: 'flex',
//           justifyContent: 'center',
//           alignItems: 'center',
//           height: '480px',
//           flexDirection: 'column',
//           backgroundColor: '#f8f9fa',
//           border: '1px solid #e9ecef',
//           borderRadius: '8px'
//         }}
//       >
//         <div
//           className="spinner"
//           style={{
//             width: '40px',
//             height: '40px',
//             border: '4px solid rgba(0, 0, 0, 0.1)',
//             borderRadius: '50%',
//             borderLeftColor: '#44BE54',
//             animation: 'spin 1s linear infinite',
//             marginBottom: '16px'
//           }}
//         ></div>
//         <style>{`
//           @keyframes spin {
//             to {
//               transform: rotate(360deg);
//             }
//           }
//         `}</style>
//         <div style={{ fontWeight: '500', color: '#555' }}>Loading Interaction Data...</div>
//       </div>
//     );
//   }

//   if (!departments?.length || !isDataAvailable) {
//     // const timeRange =
//     //   selectedTime?.start_time_string && selectedTime?.end_time_string
//     //     ? ` (${selectedTime.start_time_string} - ${selectedTime.end_time_string})`
//     //     : '';

//     return (
//       <div
//         style={{
//           display: 'flex',
//           flexDirection: 'column',
//           justifyContent: 'center',
//           alignItems: 'center',
//           height: '400px',
//           backgroundColor: '#f8f9fa',
//           border: '1px solid #e9ecef',
//           borderRadius: '8px'
//         }}
//       >
//         <p style={{ color: '#6c757d', fontSize: '16px', marginBottom: '8px' }}>
//           {!departments?.length
//             ? "Please select at least one department to view data"
//             : `No footfall data available for ${moment(date).format('LL')}`}
//         </p>
//       </div>
//     );
//   }

//   const maxCount = series.length > 0 ? Math.max(...series.flatMap((s) => s.data.map((point) => point.y)), 10) : 10;
//   const options = {
//     series: series,
//     chart: {
//       type: 'area',
//       height: 350,
//       stacked: false,
//       zoom: { enabled: false },
//       animations: {
//         enabled: isDataAvailable
//       }
//     },
//     colors: ['#008FFB', '#44be54'],
//     dataLabels: { enabled: false },
//     stroke: {
//       curve: 'smooth',
//       width: 3
//     },
//     fill: {
//       type: 'gradient',
//       gradient: {
//         shadeIntensity: 1,
//         inverseColors: false,
//         opacityFrom: 0.6,
//         opacityTo: 0.2,
//         stops: [0, 90, 100]
//       }
//     },
//     markers: {
//       size: 4,
//       hover: {
//         size: 6
//       }
//     },
//     yaxis: {
//       labels: {
//         style: { colors: '#8e8da4' },
//         formatter: (val) => val.toFixed(0)
//       },
//       axisBorder: { show: false },
//       axisTicks: { show: false },
//       title: { text: 'Count' },
//       min: 0,
//       max: Math.ceil(maxCount * 1.1),
//       tickAmount: 7
//     },
//     xaxis: {
//       type: 'datetime',
//       title: { text: 'Time' },
//       labels: {
//         rotate: -15,
//         rotateAlways: true,
//         formatter: (val) => moment(new Date(val)).format('h:mm A')
//       },
//       tickAmount: 16
//     },
//     tooltip: {
//       enabled: true,
//       shared: false,
//       intersect: false,
//       x: {
//         format: 'h:mm A'
//       }
//     },
//     legend: {
//       position: 'top',
//       horizontalAlign: 'center',
//       markers: {
//         width: 12,
//         height: 12,
//         fillColors: ['#008FFB', '#44be54']
//       }
//     },
//     grid: {
//       borderColor: '#f1f1f1',
//       strokeDashArray: 0
//     },
//     noData: {
//       text: 'No data available',
//       align: 'center',
//       verticalAlign: 'middle'
//     }
//   };

//   return (
//     <div style={{ position: 'relative', width: '100%' }}>
//       <ReactApexCharts options={options} series={series} type="area" height={480} width="100%" />
//     </div>
//   );
// };

// export default AreaChart;


// import React, { useEffect, useState, useRef } from 'react';
// import ReactApexCharts from 'react-apexcharts';
// import { useSelector } from 'react-redux';
// import { getAvailability } from 'api';
// import moment from 'moment';

// const AreaChart = () => {
//   const [series, setSeries] = useState([]);
//   const [isDataAvailable, setIsDataAvailable] = useState(false);
//   const [isLoading, setIsLoading] = useState(true);
//   const lastRequestRef = useRef(null);
//   const requestTimeoutRef = useRef(null);

//   const date = useSelector((state) => state.customization.currentDate);
//   const selectedTime = useSelector((state) => state.customization.selectedTime);
//   const source = localStorage.getItem('source');
//   const departments = useSelector((state) => state.customization.departments);
// console.log("fvfvf", departments)
//   const timeToDate = (dateStr, timeStr) => {
//     if (!timeStr) return null;
//     if (timeStr.includes('-')) {
//       const [start] = timeStr.split('-').map((t) => t.trim());
//       timeStr = start;
//     }
//     const timeMoment = moment(timeStr, ['h:mm A', 'HH:mm']);
//     if (!timeMoment.isValid()) return null;
//     const dateMoment = moment(dateStr);
//     timeMoment.set({
//       year: dateMoment.year(),
//       month: dateMoment.month(),
//       date: dateMoment.date()
//     });
//     return timeMoment.toDate();
//   };

//   useEffect(() => {
//     const fetchData = async () => {
//       if (lastRequestRef.current) {
//         lastRequestRef.current.abort();
//       }

//       const controller = new AbortController();
//       lastRequestRef.current = controller;

//       try {
//         setIsLoading(true);

//         if (!date || !selectedTime || !departments?.length) {
//           setIsDataAvailable(false);
//           return;
//         }

//         const startTime = selectedTime?.start_time ? new Date(selectedTime.start_time) : new Date();
//         const endTime = selectedTime?.end_time ? new Date(selectedTime.end_time) : new Date();

//         const response = await getAvailability(
//           {
//             date: date.split('T')[0],
//             source_id: source,
//             start_time: startTime.toUTCString(),
//             end_time: endTime.toUTCString(),
//             departments: departments
//           },
//           { signal: controller.signal }
//         );

//         if (!response?.data?.length) {
//           setIsDataAvailable(false);
//           return;
//         }

//         const processData = (data, key) => {
//           return data
//             .map((item) => {
//               const timestamp = timeToDate(date, item.time_range);
//               return timestamp ? { x: timestamp.getTime(), y: item[key] || 0 } : null;
//             })
//             .filter(Boolean);
//         };

//         // const employeeData = processData(response.data, 'employee_count'); // ⛔️ removed (commented)
//         const customerData = processData(response.data, 'customer_count');

//         // Only check customer data (Devotees)
//         if (!customerData.length) {
//           setIsDataAvailable(false);
//           return;
//         }

//         // Use a single series named "Devotees"
//         setSeries([{ name: 'Devotees', data: customerData }]);
//         setIsDataAvailable(true);
//       } catch (error) {
//         if (error.name !== 'AbortError') {
//           console.error('API Error:', error);
//           setIsDataAvailable(false);
//         }
//       } finally {
//         setIsLoading(false);
//       }
//     };

//     if (requestTimeoutRef.current) {
//       clearTimeout(requestTimeoutRef.current);
//     }

//     requestTimeoutRef.current = setTimeout(() => {
//       fetchData();
//     }, 500);

//     return () => {
//       if (requestTimeoutRef.current) {
//         clearTimeout(requestTimeoutRef.current);
//       }
//       if (lastRequestRef.current) {
//         lastRequestRef.current.abort();
//       }
//     };
//   }, [date, selectedTime, source, departments]);

//   if (isLoading) {
//     return (
//       <div
//         className="chart-loading-container"
//         style={{
//           display: 'flex',
//           justifyContent: 'center',
//           alignItems: 'center',
//           height: '480px',
//           flexDirection: 'column',
//           backgroundColor: '#f8f9fa',
//           border: '1px solid #e9ecef',
//           borderRadius: '8px'
//         }}
//       >
//         <div
//           className="spinner"
//           style={{
//             width: '40px',
//             height: '40px',
//             border: '4px solid rgba(0, 0, 0, 0.1)',
//             borderRadius: '50%',
//             borderLeftColor: '#44BE54',
//             animation: 'spin 1s linear infinite',
//             marginBottom: '16px'
//           }}
//         ></div>
//         <style>{`
//           @keyframes spin {
//             to { transform: rotate(360deg); }
//           }
//         `}</style>
//         <div style={{ fontWeight: '500', color: '#555' }}>Loading Interaction Data...</div>
//       </div>
//     );
//   }

//   if (!departments?.length || !isDataAvailable) {
//     return (
//       <div
//         style={{
//           display: 'flex',
//           flexDirection: 'column',
//           justifyContent: 'center',
//           alignItems: 'center',
//           height: '400px',
//           backgroundColor: '#f8f9fa',
//           border: '1px solid #e9ecef',
//           borderRadius: '8px'
//         }}
//       >
//         <p style={{ color: '#6c757d', fontSize: '16px', marginBottom: '8px' }}>
//           {!departments?.length
//             ? 'Please select at least one camera to view data'
//             : `No devotee data available for ${moment(date).format('LL')}`}
//         </p>
//       </div>
//     );
//   }

//   const maxCount =
//     series.length > 0 ? Math.max(...series.flatMap((s) => s.data.map((point) => point.y)), 10) : 10;

//   const options = {
//     series: series,
//     chart: {
//       type: 'area',
//       height: 350,
//       stacked: false,
//       zoom: { enabled: false },
//       animations: { enabled: isDataAvailable }
//     },
//     colors: ['#44be54'], // single color for Devotees
//     dataLabels: { enabled: false },
//     stroke: { curve: 'smooth', width: 3 },
//     fill: {
//       type: 'gradient',
//       gradient: { shadeIntensity: 1, inverseColors: false, opacityFrom: 0.6, opacityTo: 0.2, stops: [0, 90, 100] }
//     },
//     markers: { size: 4, hover: { size: 6 } },
//     yaxis: {
//       labels: { style: { colors: '#8e8da4' }, formatter: (val) => val.toFixed(0) },
//       axisBorder: { show: false },
//       axisTicks: { show: false },
//       title: { text: 'Count' },
//       min: 0,
//       max: Math.ceil(maxCount * 1.1),
//       tickAmount: 7
//     },
//     xaxis: {
//       type: 'datetime',
//       title: { text: 'Time' },
//       labels: {
//         rotate: -15,
//         rotateAlways: true,
//         formatter: (val) => moment(new Date(val)).format('h:mm A')
//       },
//       tickAmount: 16
//     },
//     tooltip: {
//       enabled: true,
//       shared: false,
//       intersect: false,
//       x: { format: 'h:mm A' }
//     },
//     legend: {
//       position: 'top',
//       horizontalAlign: 'center',
//       markers: { width: 12, height: 12, fillColors: ['#44be54'] },
//       labels: { colors: '#333' }
//     },
//     grid: { borderColor: '#f1f1f1', strokeDashArray: 0 },
//     noData: { text: 'No devotee data', align: 'center', verticalAlign: 'middle' }
//   };

//   return (
//     <div style={{ position: 'relative', width: '100%' }}>
//       <ReactApexCharts options={options} series={series} type="area" height={480} width="100%" />
//     </div>
//   );
// };

// export default AreaChart;






import React, { useEffect, useState, useRef } from 'react';
import ReactApexCharts from 'react-apexcharts';
import { useSelector } from 'react-redux';
import { getAvailability } from 'api';
import moment from 'moment';

const AreaChart = () => {
  const [series, setSeries] = useState([]);
  const [isDataAvailable, setIsDataAvailable] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const lastRequestRef = useRef(null);
  const requestTimeoutRef = useRef(null);

  const date = useSelector((state) => state.customization.currentDate);
  const selectedTime = useSelector((state) => state.customization.selectedTime);
  const source = localStorage.getItem('source');
  const departments = useSelector((state) => state.customization.departments);

  const timeToDate = (dateStr, timeStr) => {
    if (!timeStr) return null;
    if (timeStr.includes('-')) {
      const [start] = timeStr.split('-').map((t) => t.trim());
      timeStr = start;
    }
    const timeMoment = moment(timeStr, ['h:mm A', 'HH:mm']);
    if (!timeMoment.isValid()) return null;
    const dateMoment = moment(dateStr);
    timeMoment.set({
      year: dateMoment.year(),
      month: dateMoment.month(),
      date: dateMoment.date()
    });
    return timeMoment.toDate();
  };

  useEffect(() => {
    const fetchData = async () => {
      if (lastRequestRef.current) {
        lastRequestRef.current.abort();
      }

      const controller = new AbortController();
      lastRequestRef.current = controller;

      try {
        setIsLoading(true);

        // Only fetch data for the 15th and 16th dates
        const day = moment(date).date();
        if (day !== 15 && day !== 16) {
          setIsDataAvailable(false);
          setSeries([]);
          return;
        }

        if (!date || !selectedTime || !departments?.length) {
          setIsDataAvailable(false);
          return;
        }

        const startTime = selectedTime?.start_time ? new Date(selectedTime.start_time) : new Date();
        const endTime = selectedTime?.end_time ? new Date(selectedTime.end_time) : new Date();

        const response = await getAvailability(
          {
            date: date.split('T')[0],
            source_id: source,
            start_time: startTime.toUTCString(),
            end_time: endTime.toUTCString(),
            departments: departments
          },
          { signal: controller.signal }
        );

        if (!response?.data?.length) {
          setIsDataAvailable(false);
          return;
        }

        const processData = (data, key) => {
          return data
            .map((item) => {
              const timestamp = timeToDate(date, item.time_range);
              return timestamp ? { x: timestamp.getTime(), y: item[key] || 0 } : null;
            })
            .filter(Boolean);
        };

        const customerData = processData(response.data, 'customer_count');

        // Only check customer data (Devotees)
        if (!customerData.length) {
          setIsDataAvailable(false);
          return;
        }

        // Use a single series named "Devotees"
        setSeries([{ name: 'Devotees', data: customerData }]);
        setIsDataAvailable(true);
      } catch (error) {
        if (error.name !== 'AbortError') {
          console.error('API Error:', error);
          setIsDataAvailable(false);
        }
      } finally {
        setIsLoading(false);
      }
    };

    if (requestTimeoutRef.current) {
      clearTimeout(requestTimeoutRef.current);
    }

    requestTimeoutRef.current = setTimeout(() => {
      fetchData();
    }, 500);

    return () => {
      if (requestTimeoutRef.current) {
        clearTimeout(requestTimeoutRef.current);
      }
      if (lastRequestRef.current) {
        lastRequestRef.current.abort();
      }
    };
  }, [date, selectedTime, source, departments]);

  if (isLoading) {
    return (
      <div
        className="chart-loading-container"
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '480px',
          flexDirection: 'column',
          backgroundColor: '#f8f9fa',
          border: '1px solid #e9ecef',
          borderRadius: '8px'
        }}
      >
        <div
          className="spinner"
          style={{
            width: '40px',
            height: '40px',
            border: '4px solid rgba(0, 0, 0, 0.1)',
            borderRadius: '50%',
            borderLeftColor: '#44BE54',
            animation: 'spin 1s linear infinite',
            marginBottom: '16px'
          }}
        ></div>
        <style>{`
          @keyframes spin {
            to { transform: rotate(360deg); }
          }
        `}</style>
        <div style={{ fontWeight: '500', color: '#555' }}>Loading Interaction Data...</div>
      </div>
    );
  }

  if (!departments?.length || !isDataAvailable) {
    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          height: '400px',
          backgroundColor: '#f8f9fa',
          border: '1px solid #e9ecef',
          borderRadius: '8px'
        }}
      >
        <p style={{ color: '#6c757d', fontSize: '16px', marginBottom: '8px' }}>
          {!departments?.length
            ? 'Please select at least one camera to view data'
            : `No devotee data available for the selected date ${moment(date).format('LL')}`}
        </p>
      </div>
    );
  }

  const maxCount =
    series.length > 0 ? Math.max(...series.flatMap((s) => s.data.map((point) => point.y)), 10) : 10;

  const options = {
    series: series,
    chart: {
      type: 'area',
      height: 350,
      stacked: false,
      zoom: { enabled: false },
      animations: { enabled: isDataAvailable }
    },
    colors: ['#44be54'], // single color for Devotees
    dataLabels: { enabled: false },
    stroke: { curve: 'smooth', width: 3 },
    fill: {
      type: 'gradient',
      gradient: { shadeIntensity: 1, inverseColors: false, opacityFrom: 0.6, opacityTo: 0.2, stops: [0, 90, 100] }
    },
    markers: { size: 4, hover: { size: 6 } },
    yaxis: {
      labels: { style: { colors: '#8e8da4' }, formatter: (val) => val.toFixed(0) },
      axisBorder: { show: false },
      axisTicks: { show: false },
      title: { text: 'Count' },
      min: 0,
      max: Math.ceil(maxCount * 1.1),
      tickAmount: 7
    },
    xaxis: {
      type: 'datetime',
      title: { text: 'Time' },
      labels: {
        rotate: -15,
        rotateAlways: true,
        formatter: (val) => moment(new Date(val)).format('h:mm A')
      },
      tickAmount: 16
    },
    tooltip: {
      enabled: true,
      shared: false,
      intersect: false,
      x: { format: 'h:mm A' }
    },
    legend: {
      position: 'top',
      horizontalAlign: 'center',
      markers: { width: 12, height: 12, fillColors: ['#44be54'] },
      labels: { colors: '#333' }
    },
    grid: { borderColor: '#f1f1f1', strokeDashArray: 0 },
    noData: { text: 'No devotee data', align: 'center', verticalAlign: 'middle' }
  };

  return (
    <div style={{ position: 'relative', width: '100%' }}>
      <ReactApexCharts options={options} series={series} type="area" height={480} width="100%" />
    </div>
  );
};

export default AreaChart;
